if (typeof ArticleContent !== 'function') {
	class ArticleContent extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				links: 'a:not([href^="#"])',
			};

			this.elements = {
				links: this.querySelectorAll(this.selectors.links),
			};

			this.shopUrl = this.dataset.shopUrl;

			this.init();
		}

		async init() {
			this.elements.links.forEach(async (a) => {
				const link = a.getAttribute('href');

				if (link.includes('products/') && link.includes(this.shopUrl)) {
					const handleProduct = link.split('products/')[1];

					const product = await this.getProductData(handleProduct);

					if (!product.id) return;

					this.createQuickBuy(a, link, product);
				}
			});
		}

		createQuickBuy(a, link, product) {
			const quickBuy = document.createElement('quick-buy');

			quickBuy.setAttribute('data-url', link);
			quickBuy.setAttribute('data-id', product.id);
			quickBuy.setAttribute('data-has-variants', true);
			quickBuy.innerHTML = a.textContent;

			a.parentNode.replaceChild(quickBuy, a);
		}

		async getProductData(productHandle) {
			const language = window.routes.root;
			const fetchLink = `${window.location.origin}${language}products/${productHandle}.js`;

			try {
				const response = await fetch(fetchLink, {
					method: 'GET',
				});

				return response.json();
			} catch (error) {
				console.error(error);
			}
		}
	}

	if (!customElements.get('article-content')) {
		customElements.define('article-content', ArticleContent);
	}
}
